import { useCallback, useEffect, useState } from "react";
import { api, API, TOKEN_KEY, authHeaders } from "@/lib/api";
import { VaultLogin } from "@/components/vault/VaultLogin";
import { VaultList } from "@/components/vault/VaultList";

export default function Vault() {
  const [state, setState] = useState(null);

  useEffect(() => {
    document.title = "Vault · Syndicate 369";
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    if (!sessionStorage.getItem(TOKEN_KEY)) { setState(false); return () => m.remove(); }
    api.get(`${API}/auth/me`, { headers: authHeaders() })
      .then((r) => setState(r.data?.email || false))
      .catch(() => { sessionStorage.removeItem(TOKEN_KEY); setState(false); });
    return () => m.remove();
  }, []);

  const logout = useCallback(() => { sessionStorage.removeItem(TOKEN_KEY); setState(false); }, []);

  if (state === null) return <div className="vault" data-testid="vault-loading" />;
  return (
    <div className="vault" data-testid="vault-page">
      {state ? <VaultList email={state} onLogout={logout} /> : <VaultLogin onIn={setState} />}
    </div>
  );
}
